<template>
<div>
  <div class="modal">
    <div class="modal-dialog">
      <div :class="{ 
        'modal-content': true, 
        'modal-warning': true,
        }">
        <div class="modal-body text-center" v-html="message">
        </div>
        <div class="modal-footer">
          <div class="btn" @click="close">關閉</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'FocusModal',
  props: ['message'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="sass" scoped>
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.modal-body
  p
    margin-bottom: 0
</style>




// WEBPACK FOOTER //
// FocusModal.vue?7b9ce484